var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.fetching,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("staff_specific_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc text-center"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("staff_specific_page.form_desc")) + " ")]), _vm.isCanBinding ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "sales__wrapper"
  }, [_vm.staffs ? _c('swiper', {
    staticClass: "sales align-items-stretch",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l(_vm.staffs, function (i, idx) {
    return _c('swiper-slide', {
      key: idx,
      staticClass: "sales__item"
    }, [_c('div', {
      staticClass: "card text-center d-flex flex-column"
    }, [_vm.showAvatar ? _c('div', [_vm.displayAvatar(i) ? _c('img', {
      staticClass: "card-img-top",
      attrs: {
        "src": _vm.displayAvatar(i)
      }
    }) : _c('img', {
      staticClass: "card-img-top",
      attrs: {
        "src": require("./default_staff_img.jpg")
      }
    })]) : _vm._e(), _c('div', {
      staticClass: "p-3 flex-fill d-flex flex-column"
    }, [_c('div', {
      staticClass: "flex-fill"
    }, [_vm.staffFields.length != 0 ? _c('table', {
      staticClass: "mx-auto my-3 align-text-top"
    }, _vm._l(_vm.staffFields, function (field, index) {
      return _c('tr', {
        key: index
      }, [field.title ? [_c('td', {
        staticClass: "font-weight-bold text-nowrap align-text-top"
      }, [_vm._v(_vm._s(field.title))]), _c('td', {
        staticClass: "text-left align-text-top"
      }, [_vm._v(_vm._s(_vm.displayField(i, field)))])] : [_c('td', {
        staticClass: "align-text-top",
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v(_vm._s(_vm.displayField(i, field)))])]], 2);
    }), 0) : [_c('div', [_vm._v(_vm._s(i.name))])]], 2)])])]);
  }), 1) : _vm._e()], 1)]) : _c('div', [_vm.getModuleConfig('staff_specific_page.multiple_bind.forbid_text') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('staff_specific_page.multiple_bind.forbid_text'))
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_vm.isCanBinding ? _c('MemberButton', {
    staticClass: "s-btn-bg-primary mb-2",
    attrs: {
      "disable-button": !_vm.selectedStaff.id,
      "button-text": _vm.displayButtonText,
      "button-url": _vm.getModuleConfig('staff_specific_page.bind_button.button_url'),
      "type": _vm.getModuleConfig('staff_specific_page.bind_button.button_action'),
      "use-callback": true
    },
    on: {
      "custom-click": _vm.handleSubmit
    }
  }) : _vm._e(), _vm.getModuleConfig('staff_specific_page.button_text') && _vm.isCanBinding ? _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.getModuleConfig('staff_specific_page.button_text'),
      "button-url": _vm.getModuleConfig('staff_specific_page.button_url'),
      "type": _vm.getModuleConfig('staff_specific_page.button_action')
    }
  }) : _vm._e(), _vm.getModuleConfig('staff_specific_page.multiple_bind.button_text') && !_vm.isCanBinding ? _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.getModuleConfig('staff_specific_page.multiple_bind.button_text'),
      "button-url": _vm.getModuleConfig('staff_specific_page.multiple_bind.button_url'),
      "type": _vm.getModuleConfig('staff_specific_page.multiple_bind.button_action')
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }